<div *ngIf="evChartOptions" class="card mt-2">
    <div class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
        <div class="column" style="width: 100%;">
            <h6 class="m-0">Evolutivo por {{selectedToggle == 'COMPRA' ? 'proveedor' : 'cliente'}}</h6>
            <!-- <div [chart]="evProvChartOptions" class="graphContent"></div> -->
            <!-- <app-lcv-ev-column-chart [chartOptions]="evProvChartOptions"></app-lcv-ev-column-chart> -->
            <apx-chart
                [series]="evChartOptions.series"
                [chart]="evChartOptions.chart"
                [dataLabels]="evChartOptions.dataLabels"
                [plotOptions]="evChartOptions.plotOptions"
                [xaxis]="evChartOptions.xaxis"
                [yaxis]="evChartOptions.yaxis"
            ></apx-chart>
        </div>
    </div>
</div>